import React, { useEffect, useState } from 'react';
import { CheckCircleIcon, XIcon } from 'lucide-react';
interface MicroFeedbackProps {
  message: string;
  duration?: number;
  onClose?: () => void;
}
const MicroFeedback: React.FC<MicroFeedbackProps> = ({
  message,
  duration = 3000,
  onClose
}) => {
  const [visible, setVisible] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      if (onClose) onClose();
    }, duration);
    return () => clearTimeout(timer);
  }, [duration, onClose]);
  if (!visible) return null;
  return <div className="fixed bottom-16 left-1/2 transform -translate-x-1/2 bg-white border-2 border-gray-300 shadow-md rounded-lg py-3 px-4 flex items-center max-w-xs" data-id="element-615">
      <CheckCircleIcon className="w-5 h-5 text-gray-700 mr-3 flex-shrink-0" data-id="element-616" />
      <p className="text-sm text-gray-800" data-id="element-617">{message}</p>
      <button className="ml-3 text-gray-500 hover:text-gray-700" onClick={() => {
      setVisible(false);
      if (onClose) onClose();
    }} data-id="element-618">
        <XIcon className="w-4 h-4" data-id="element-619" />
      </button>
    </div>;
};
export default MicroFeedback;